// extracted by mini-css-extract-plugin
module.exports = {"root":"topbar-user-menu-content-profile-switch_root__PgMOK","list":"topbar-user-menu-content-profile-switch_list__kcXFg"};